"use strict";

exports.__esModule = true;
exports.StyledTooltip = void 0;

var _reactTooltip = require("@radix-ui/react-tooltip");

var _styled = require("@manifest-ui/styled");

const StyledTooltip = (0, _styled.styled)(_reactTooltip.TooltipContent, {
  themeKey: 'tooltip'
})({
  backgroundColor: 'emphasis.secondary',
  borderRadius: 'large',
  boxShadow: 'large',
  boxSizing: 'border-box',
  color: 'white',
  fontFamily: 'body',
  fontSize: 'x-small',
  fontWeight: 'semibold',
  letterSpacing: 'normal',
  lineHeight: 'small',
  overflow: 'hidden',
  position: 'relative',
  px: 2,
  py: 1
});
exports.StyledTooltip = StyledTooltip;